import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const S = {
  page: {
    minHeight: '100vh', background: '#080810',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '1rem', fontFamily: "'Oswald','Arial Black',sans-serif"
  },
  card: {
    background: '#14141f', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16, padding: '2.5rem 2rem',
    maxWidth: 400, width: '100%', textAlign: 'center', color: '#F5F5F0'
  },
  logo: { fontSize: 22, fontWeight: 700, letterSpacing: 3, marginBottom: 6 },
  title: { fontSize: 20, letterSpacing: 2, marginBottom: 6, marginTop: 20 },
  sub: { fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6B7B', marginBottom: 28 },
  btnGoogle: {
    width: '100%', padding: 14,
    background: '#fff', border: 'none', borderRadius: 10,
    fontFamily: "'Inter',sans-serif", fontSize: 15, fontWeight: 600,
    color: '#080810', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10
  },
  btnGhost: {
    background: 'none', border: 'none',
    fontFamily: "'Inter',sans-serif", fontSize: 13,
    color: '#6B6B7B', cursor: 'pointer', marginTop: 16
  },
  errBox: {
    background: 'rgba(230,57,70,0.08)', border: '1px solid rgba(230,57,70,0.2)',
    borderRadius: 8, padding: '10px 14px', marginBottom: 16,
    fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#E63946'
  },
  divider: {
    borderTop: '1px solid rgba(255,255,255,0.07)',
    margin: '20px 0', position: 'relative'
  },
  infoBox: {
    background: 'rgba(240,180,41,0.06)', border: '1px solid rgba(240,180,41,0.15)',
    borderRadius: 8, padding: '12px 14px', marginTop: 20,
    fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#F0B429', textAlign: 'left'
  }
};

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { loginAdmin } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleGoogleLogin() {
  setLoading(true);
  setError('');
  // â”€â”€ DEBUG TEMPORAL â”€â”€
  console.log('ðŸ” isNative:', !!(window.Capacitor && window.Capacitor.isNative));
  console.log('ðŸ” Capacitor:', JSON.stringify(window.Capacitor));
  // â”€â”€ FIN DEBUG â”€â”€
  try {
    await loginAdmin();
    navigate('/mis-grupos');
  } catch (err) {
    setError('Error: ' + (err?.message || err?.code || JSON.stringify(err)));
  } finally {
    setLoading(false);
  }
}

  return (
    <div style={S.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&family=Inter:wght@400;500&display=swap');
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <div style={S.card}>
        <div style={{ fontSize: 36, marginBottom: 8 }}>ðŸ‘‘</div>
        <div style={S.logo}>PITAZO<span style={{ color: '#F0B429' }}>MUNDIAL</span></div>
        <div style={S.title}>PANEL DE ADMIN</div>
        <div style={S.sub}>Inicia sesiÃ³n para gestionar tu grupo</div>

        {error && <div style={S.errBox}>{error}</div>}

        <button style={{ ...S.btnGoogle, opacity: loading ? 0.8 : 1, position: 'relative' }} onClick={handleGoogleLogin} disabled={loading}>
          {loading ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 18, height: 18, border: '3px solid rgba(8,8,16,0.2)', borderTop: '3px solid #080810', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, color: '#080810' }}>INICIANDO SESIÃ“N...</span>
            </div>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2.04a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.48A4.8 4.8 0 0 1 4.5 7.52V5.45H1.83a8 8 0 0 0 0 7.1z"/>
                <path fill="#EA4335" d="M8.98 3.58c1.32 0 2.5.45 3.44 1.35l2.56-2.56A8 8 0 0 0 1.83 5.45L4.5 7.52A4.8 4.8 0 0 1 8.98 3.58z"/>
              </svg>
              CONTINUAR CON GOOGLE
            </>
          )}
        </button>

        <div style={S.infoBox}>
          ðŸ’¡ El admin es quien <strong>crea y gestiona</strong> el grupo, genera los links de invitaciÃ³n y configura los puntos.
        </div>

        <br />
        <button style={S.btnGhost} onClick={() => navigate('/')}>â† Volver al inicio</button>
      </div>
    </div>
  );
} 


